/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Questionnaire_Reportemailsubject2Inputs */

const en_questionnaire_reportemailsubject2 = /** @type {(inputs: Questionnaire_Reportemailsubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem with the questionnaire`)
};

const fr_questionnaire_reportemailsubject2 = /** @type {(inputs: Questionnaire_Reportemailsubject2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problème avec le questionnaire`)
};

/**
* | output |
* | --- |
* | "Problem with the questionnaire" |
*
* @param {Questionnaire_Reportemailsubject2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const questionnaire_reportemailsubject2 = /** @type {((inputs?: Questionnaire_Reportemailsubject2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Questionnaire_Reportemailsubject2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_questionnaire_reportemailsubject2(inputs)
	return fr_questionnaire_reportemailsubject2(inputs)
});
export { questionnaire_reportemailsubject2 as "questionnaire_reportEmailSubject" }